



























































import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Getter } from 'vuex-class'

@Component
export default class LoginDialog extends Vue {
    valid = true
    password = ''
    error: Error | null = null
    showError = false
    requiredRules = [
        (v: any) => (!!v) || 'This field is required',
    ]
    @State(s => s.auth.username) username!: string
    setUsername(username: string) {
        this.$store.commit('auth/setUsername', username)
    }
    mounted() {
        const loginInput = this.$refs.login as HTMLInputElement
        loginInput.focus()
    }
    keypressLogin(event: KeyboardEvent) {
        if (event.keyCode === 13) {
            const pwInput = this.$refs.password as HTMLInputElement
            pwInput.focus()
        }
    }
    keypressPassword(event: KeyboardEvent) {
        if (event.keyCode === 13) {
            this.login()
        }
    }
    async login() {
        this.showError = false
        this.error = null
        let form: any = this.$refs.form
        if (form.validate()) {
            try {
                await this.$store.dispatch('auth/login', { password: this.password })
            } catch (e) {
                this.error = e.message
                this.showError = true
            }
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoginDialog.vue